import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Slider from "Shared/Slider";
import { analyticsFEA } from "src/AnalyticsFEA";
import { ApplicationStore } from "src/store";
import { patchPaymentsRequest } from "src/store/actions/payments";
import { getLeaseMileOptions, getLeaseMiles, getVehicle } from "src/store/selectors/vehicles";

interface Props {
    vin: string;
}

const Miles = ({
    milesOptions,
    milesValue,
    uuid,
    vin,
    region,
    patchPayments,
    vehicle,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const handleChange = (index: number) => {
        patchPayments(
            uuid,
            vin,
            {
                lease: {
                    miles: milesOptions[index],
                },
            },
            "set_lease_mileage"
        );

        analyticsFEA.engine.calculationStart(uuid, [vehicle]);
    };

    return (
        <div className="CalculatorSlider">
            <div className="CalculatorSlider__container--input">
                <input
                    className="CalculatorSlider__input"
                    value={`${milesValue.toLocaleString()} ${
                        region === "CA"
                            ? t("CustomizePayment.PaymentFields.kilometers")
                            : t("CustomizePayment.PaymentFields.miles")
                    }`}
                    readOnly
                    disabled
                />
            </div>
            <div className="CalculatorSlider__container--slider">
                <Slider
                    className="TermSlider"
                    min={0}
                    max={milesOptions.length - 1}
                    sliderValue={milesOptions.indexOf(milesValue)}
                    step={1}
                    onChange={handleChange}
                    ticks={milesOptions.map((value: number) => value / 1000)}
                    tickLabel="k"
                    tickPrefix=""
                    controlled={true}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    return {
        vehicle: getVehicle(state, vin),
        milesOptions: getLeaseMileOptions(state, vin),
        milesValue: getLeaseMiles(state, vin),
        uuid: state.deal.uuid!,
        region: state.account.address?.country,
    };
};

const mapDispatchToProps = {
    patchPayments: patchPaymentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Miles);
